import type { TodoResponse } from '@/api/types/todo'
import { ensureUtc } from '@/lib/date-utils'

export const DEFAULT_DURATION_MIN = 30

/** 日ビューへの HTML5 DnD で TODO ID を渡す MIME タイプ */
export const PARKED_TODO_MIME = 'application/x-parked-todo-id'

/** スケジュール済み Todo の所要時間 (分) */
export const getScheduledMinutes = (todo: TodoResponse) => {
  if (!todo.scheduled_start || !todo.scheduled_end) return todo.estimated_minutes ?? DEFAULT_DURATION_MIN
  const ms = new Date(ensureUtc(todo.scheduled_end)).getTime() - new Date(ensureUtc(todo.scheduled_start)).getTime()
  return ms > 0 ? Math.round(ms / 60000) : DEFAULT_DURATION_MIN
}

/** ポインタ (マウス / タッチ) が要素の矩形内にあるか */
export const isPointerInside = (el: HTMLElement | null, ev: MouseEvent | TouchEvent) => {
  if (!el) return false
  const point = 'changedTouches' in ev ? ev.changedTouches.item(0) : ev
  if (!point) return false
  const r = el.getBoundingClientRect()
  return point.clientX >= r.left && point.clientX <= r.right && point.clientY >= r.top && point.clientY <= r.bottom
}
